module.exports = __webpack_public_path__ + "static/media/VSERIES.a32a0d73.pdf";